import styles from './DownloadAppBottomSheet.module.scss'
import { Icon } from '@/components'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import { getMobileApps } from '@/store/slices/stagesSlice/stagesSlice'
import { OperatingSystem, storeLinks } from '@/constants'
import { yandexMetrika } from '@/helpers/yandexMetrika'
import { useEffect, useRef, useState } from 'react'
import { getUserAgent } from '@/helpers/getUserAgent'
import cn from 'classnames'
import { ONELINK_MOBILE_APP } from '@/constants/links'

export const DownloadAppBottomSheet = () => {
  const reduxState = useSelector<RootState, RootState>(state => state)
  const { data: mobileApps } = getMobileApps(reduxState)
  const [operatingSystem, setOperatingSystem] = useState<OperatingSystem | 'other'>('other')
  const [openBottomSheet, setOpenBottomSheet] = useState(false)
  const [isAnimatingClose, setIsAnimatingClose] = useState(false)
  const timeoutId = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    const operatingSystem = getUserAgent()
    setOperatingSystem(operatingSystem)
  }, [])

  useEffect(() => {
    if (operatingSystem === OperatingSystem.Android) {
      yandexMetrika.reachGoalButtonViewGooglePlayNew()
    }

    if (operatingSystem === OperatingSystem.IOS) {
      yandexMetrika.reachGoalButtonViewAppStoreNew()
    }
  }, [operatingSystem])

  useEffect(() => {
    timeoutId.current = setTimeout(() => {
      setOpenBottomSheet(true)
      setIsAnimatingClose(true)
    }, 1500)
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current)
      }
    }
  }, [])

  return (
    <div className={cn(styles.modal, { [styles.modal_open]: openBottomSheet })}>
      <div
        className={cn(styles.modal__container, {
          [styles.modal__container_close]: !isAnimatingClose,
        })}
      >
        <div className={styles.modal__containerImg}>
          <div
            onClick={() => {
              setIsAnimatingClose(false)
              setTimeout(() => setOpenBottomSheet(false), 350)
            }}
            className={styles.modalCloseIcon}
          >
            <Icon name={'modal-close-icon'} fill={'white'} />
          </div>
        </div>
        <div className={styles.modal__containerContent}>
          <h3 className={styles.modal__title}>
            Оплачивайте парковку ещё&nbsp;быстрее в приложении
          </h3>
          <p className={styles.modal__desc}>
            Находите парковки, следите за временем и&nbsp;оплачивайте абонементы в приложении
          </p>
          {operatingSystem === OperatingSystem.IOS && (
            <a
              target="_blank"
              className={styles.buttonLinkIos}
              href={ONELINK_MOBILE_APP}
              onClick={yandexMetrika.reachGoalButtonClickAppStoreNew}
            >
              Скачать приложение
            </a>
          )}
          {operatingSystem !== OperatingSystem.IOS && (
            <div className={styles.containerButton}>
              <a
                target="_blank"
                className={styles.buttonLink}
                href={mobileApps?.rustore_link || storeLinks.rustore}
                onClick={() => {}}
              >
                <img src="/images/RustoreButton.png" alt="rustore store link" />
              </a>
              <a
                target="_blank"
                className={styles.buttonLink}
                href={ONELINK_MOBILE_APP}
                onClick={yandexMetrika.reachGoalButtonClickGooglePlayNew}
              >
                <img src="/images/GoogleButton.png" alt="google store link" />
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
